export const baseUrl = {
  development: 'http://localhost:3001',
  test: 'http://localhost:3001',
  production: process.env.DOMAIN_URL || 'https://bumble.com',
}[process.env.NODE_ENV];
